export default {"src":"/_next/static/media/doghouse_24.c2f5ab62.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};